<template>
  <a-card class="BusinessEvaluation">
    <div @keyup.enter="getList(1)" style="margin-bottom: 15px">
      <a-form-model layout="inline">
        <a-form-model-item label="游戏名称">
          <a-input allowClear placeholder="请输入游戏名称" :maxLength="20" v-model="search.Name" />
        </a-form-model-item>
        <a-form-model-item label="版本名称">
          <a-input allowClear placeholder="请输入版本名称" :maxLength="20" v-model="search.versionName" />
        </a-form-model-item>
        <a-form-model-item label="能力维度">
          <a-cascader v-model="selectId" :options="options" :load-data="loadData" placeholder="请选择能力维度" change-on-select @change="onChange" />
        </a-form-model-item>
        <a-form-model-item label="适用年龄">
          <a-input-group compact>
            <a-input-number style="width: 100px; text-align: center" placeholder="最小年龄" type="number" :precision="0" :min="1" :max="150" v-model="search.minAge" />
            <a-input style="width: 30px; border-left: 0; pointer-events: none; backgroundcolor: #fff" placeholder="~" disabled />
            <a-input-number style="width: 100px; text-align: center; border-left: none" placeholder="最大年龄" :precision="0" :min="search.minAge" :max="150" type="number" v-model="search.maxAge" />
          </a-input-group>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="getList(1)">查询</a-button>
        </a-form-model-item>
        <!-- <a-form-model-item>
					<a-button @click="addEgame()" type="primary" icon="plus">添加游戏</a-button>
				</a-form-model-item> -->
      </a-form-model>
    </div>
    <div class="table" style="margin-top: 25px">
      <a-table
        style="min-width: 800px"
        :customRow="customRow"
        :columns="columns"
        row-key="id"
        :pagination="tableRelevant.tablePagination"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :dataSource="tableRelevant.tableDataSource"
        @change="changeSort"
      >
        <div slot="contentName" slot-scope="text">
          <div class="table_div">
            {{ text.contentName }}
          </div>
        </div>
        <div slot="abilityTypeName" slot-scope="text">
          <div class="self_td" v-for="item in text.abilitys" :key="item.id">
            {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
            {{ item.secondAbilityName }}
          </div>
        </div>
        <div slot="estimatedTime" slot-scope="text, record">
          {{ EstimatedTime(record.estimatedTime) }}
        </div>
        <div slot="device" slot-scope="text, record">
          <span v-for="item in hardwareList" :key="item.id">
            <!-- {{ (item.id | text.hardwareRequirements) == text.hardwareRequirements ? item.name : ''}} -->
            <img style="width: 20px; margin-left: 10px" :src="item.icon" alt="" v-if="(item.id | text.hardwareRequirements) == text.hardwareRequirements" />
          </span>
        </div>
        <div slot="status" slot-scope="text, record" v-auth="`Status`">
          <a-switch checked-children="启用" un-checked-children="禁用" :checked="record.enabled" @click.native.stop="StatusChange(record)" />
        </div>
        <div slot="ages" slot-scope="text, record">{{ record.minAge }} - {{ record.maxAge }}</div>
        <div slot="action" slot-scope="text, record" @click.stop="(e) => e.preventDefault()">
          <a @click.stop="edit(record)" v-permission="`/content/BusinessEvaluation/EvaluationgameSeting`" style="margin-right: 15px">编辑</a>
          <a @click.stop="viewGame(record)" v-permission="`Preview`" style="margin-right: 15px">预览</a>
          <m-dropdown>
            <a class="ant-dropdown-link" @click.stop="(e) => e.preventDefault()">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-permission="`/content/BusinessEvaluation/Statistics`">
                <a @click="Statistics(record)">统计</a>
              </a-menu-item>
              <a-menu-item v-permission="`Video`">
                <a @click="video(record)">视频</a>
              </a-menu-item>
              <a-menu-item v-permission="`Convert`">
                <a style="color: #34a852" @click="toScience(text)">转科研</a>
              </a-menu-item>
            </a-menu>
          </m-dropdown>
        </div>
      </a-table>
    </div>
    <a-drawer width="600" title="游戏详情" placement="right" :visible="drawer.visible" @close="onClose">
      <div class="card">
        <h5>基本信息</h5>
        <div class="item">
          <span>适用性别</span>
          <em>{{ drawer.data.applicableGender == 1 ? '男' : drawer.data.applicableGender == 2 ? '女' : '均可' }}</em>
        </div>
        <div class="item">
          <span>适用年龄</span>
          <em v-if="drawer.data.minAge && drawer.data.maxAge">{{ drawer.data.minAge }} - {{ drawer.data.maxAge }}岁</em>
          <em v-else>无</em>
        </div>
        <div class="item">
          <span>最佳年龄</span>
          <em v-if="drawer.data.optimumAge">{{ drawer.data.optimumAge }}岁</em>
          <em v-else>无</em>
        </div>
        <div class="item">
          <span>设备要求</span>
          <em v-if="drawer.data.hardwareRequirements > 0">
            <i v-for="item in hardwareList" :key="item.id" style="font-style: normal">
              {{ (item.id | drawer.data.hardwareRequirements) == drawer.data.hardwareRequirements ? item.name : '' }}
            </i>
          </em>
          <em v-else>无</em>
        </div>
        <div class="item">
          <span>课程体系</span>
          <em v-if="drawer.data.suitableCourses.length">
            <i v-for="item in drawer.data.suitableCourses" :key="item.id" style="font-style: normal">
              {{ item }}
            </i>
          </em>
          <em v-else>无</em>
        </div>
      </div>
      <div class="card">
        <h5>算分与常模</h5>
        <div class="table" style="margin-top: 25px">
          <a-table
            style="min-width: 400px"
            :columns="drawer.drawerColumns"
            row-key="id"
            :pagination="false"
            :loading="drawer.tableRelevant.tableLoading"
            :locale="drawer.tableRelevant.locale"
            :dataSource="drawer.tableRelevant.tableDataSource"
          >
            <div slot="abilityTypeName" slot-scope="text">
              {{ text.abilityTypeName }}- {{ text.firstAbilityName }}-
              {{ text.secondAbilityName }}
            </div>
            <div slot="algorithmCode" slot-scope="text">
              {{ text.algorithmCode ? text.algorithmCode : '--' }}
            </div>
            <div slot="sampleSize" slot-scope="text">
              <a-popconfirm v-if="text.errorList.length">
                <template slot="title">
                  <p v-for="item in text.errorList">
                    <span v-for="m in drawer.equipmentList">
                      <!-- {{ drawer.equipmentList[item.errorDeviceType] }} -->
                      {{ m.id == item.errorDeviceType ? m.name : '' }}
                    </span>
                    缺少
                    {{ item.errorAges.join('、') }}
                  </p>
                </template>
                <a-icon type="exclamation-circle" theme="filled" class="table_icon" @click.stop="test" v-if="text.errorList.length" />
              </a-popconfirm>

              <a @click.stop="normSeting(text)" style="text-decoration: underline">{{ text.sampleSize > 0 ? text.sampleSize : '--' }}</a>
            </div>
          </a-table>
        </div>
      </div>
    </a-drawer>
    <!-- 关联视频 -->
    <a-modal v-model="relationModle.visible" title="关联视频" @ok="relationOk" width="50%">
      <a-form-model ref="ruleForm" :model="relationModle" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item :ref="'Part' + (index + 1)" :label="'Part' + (index + 1)" class="part" v-for="(item, index) in relationModle.part" :key="index">
          <div class="inBox" @click="pick(item, index)">{{ item.contentName }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.firstAbilityName }}</div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 选择视频 -->
    <a-modal v-model="pickModle.visible" title="选择视频" @ok="pickOk" width="60%">
      <a-form-model layout="inline">
        <a-form-model-item label="视频名称">
          <a-input placeholder="请输入视频名称" allow-clear :maxLength="20" v-model="pickModle.name" @keyup.enter="getList(1)" />
        </a-form-model-item>
        <a-form-model-item label="一级能力">
          <a-tree-select v-model="pickModle.firstAbilityId" treeDefaultExpandAll style="width: 172px" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="选择所属模块" allow-clear>
            <a-tree-select-node :key="items.id" :title="items.name" :value="items.id" v-for="items in treeData" :selectable="false">
              <template v-if="items.children">
                <a-tree-select-node :key="item.id" :title="item.name" :value="item.id" v-for="item in items.children">
                  <template v-if="item.children">
                    <a-tree-select-node :key="el.id" :title="el.name" :value="el.id" v-for="el in item.children" />
                  </template>
                </a-tree-select-node>
              </template>
            </a-tree-select-node>
          </a-tree-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="getModleList(1)">查询</a-button>
        </a-form-model-item>
      </a-form-model>
      <div class="table" style="margin-top: 25px">
        <a-table
          style="min-width: 800px"
          :columns="videoColumns"
          ref="videoTable"
          row-key="id"
          :row-selection="rowSelection"
          :pagination="relationModleTableRelevant.tablePagination"
          :loading="relationModleTableRelevant.tableLoading"
          :locale="relationModleTableRelevant.locale"
          :dataSource="relationModleTableRelevant.tableDataSource"
        >
          <div slot="firstAbilityName" slot-scope="text, record">
            <div v-for="item in record.abilitys" :key="item.id">
              <span v-if="item.firstAbilityName == item.firstAbilityId"></span>
              <span v-else>{{ item.firstAbilityName }}</span>
            </div>
          </div>
        </a-table>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import { EstimatedTime } from '@/utils/EstimatedTime'

const columns = [
  { title: '游戏名', dataIndex: 'name', width: 200 },
  { title: '版本名称', dataIndex: 'versionName', width: 100 },
  { title: '能力维度', class: 'testClass', key: 'abilityTypeName', align: 'center', scopedSlots: { customRender: 'abilityTypeName' } },
  { title: '用时', scopedSlots: { customRender: 'estimatedTime' }, align: 'center', key: 'time' },
  { title: '设备要求', scopedSlots: { customRender: 'device' }, align: 'center', key: 'device' },
  { title: '适用年龄', scopedSlots: { customRender: 'ages' }, align: 'center', key: 'ages' },
  { title: '创建时间', align: 'center', key: 'createTime', dataIndex: 'createTime', sorter: true },
  { title: '修改时间', align: 'center', key: 'updateTime', dataIndex: 'updateTime', sorter: true },
  { title: '操作', align: 'center', scopedSlots: { customRender: 'action' }, width: 250 },
]
const drawerColumns = [
  { title: '能力维度', class: 'testClass', key: 'abilityTypeName', align: 'center', scopedSlots: { customRender: 'abilityTypeName' } },
  { title: '算分码', scopedSlots: { customRender: 'algorithmCode' }, width: 100 },
  { title: '常模样本量', scopedSlots: { customRender: 'sampleSize' }, width: 150 },
]
const enabledColumns = [
  { title: '系列', dataIndex: 'code1', width: 100 },
  { title: '课程名称', dataIndex: 'code', width: 100 },
  { title: '课时名称', dataIndex: 'num', width: 100 },
]
const videoColumns = [
  { title: '视频名称', key: '1', dataIndex: 'contentName' },
  { title: '一级能力', key: '2', scopedSlots: { customRender: 'firstAbilityName' } },
  { title: '视频时长', key: '3', dataIndex: 'endTime' },
  { title: '备注', key: '4', dataIndex: 'remark' },
]
export default {
  data() {
    return {
      selectId: [],
      options: [],
      search: {
        ContentType: 1,
        classifyTag: 1,
        Name: this.$route.query.Name,
        versionName: this.$route.query.versionName,
        AbilityTypeId: undefined,
        FirstAbilityId: undefined,
        SecondAbilityId: undefined,
        minAge: this.$route.query.minAge,
        maxAge: this.$route.query.maxAge,
      },
      EstimatedTime,
      columns,
      tableRelevant: tableRelevant.call(this, this.getList),
      // 点击行
      customRow: (record, index) => ({
        on: {
          click: () => {
            this.drawer.info = record
            this.drawer.contentId = record.id
            this.getDetailByid(record)
            this.getAbilityWithAlgorithmCode(record)
          },
        },
      }),

      // 抽屉
      drawer: {
        visible: false,
        info: {},
        drawerColumns,
        contentVersion: '',
        contentId: '',
        data: {
          applicableGender: '',
          minAge: '',
          maxAge: '',
          optimumAge: '',
          hardwareRequirements: '',
          suitableCourses: [],
        },
        equipmentList: [
          { id: 1, name: '其他' },
          { id: 2, name: '键盘' },
          { id: 4, name: '鼠标' },
          { id: 8, name: '触摸屏' },
        ],
        tableRelevant: tableRelevant.call(this, this.getAbilityWithAlgorithmCode),
      },
      //设备
      hardwareList: [
        { id: 4, name: '耳机', icon: require('@/assets/img/ej.png') },
        { id: 8, name: '麦克风', icon: require('@/assets/img/mkf.png') },
        { id: 32, name: '陀螺仪', icon: require('@/assets/img/tly.png') },
      ],

      //关联视频
      relationModle: {
        visible: false,
        part: [
          { contentName: '', firstAbilityName: '' },
          { contentName: '', firstAbilityName: '' },
          { contentName: '', firstAbilityName: '' },
        ],
      },
      videoColumns,
      relationModleTableRelevant: tableRelevant.call(this, this.getModleList),
      //选择视频
      pickModle: {
        visible: false,
        name: '',
        firstAbilityId: '',
      },
      conselectedRow: [],
      currentPart: 0,
      selectedRows: [],
      treeData: [],
      contentId: '',
      oldRadioValue: '',
    }
  },
  mounted() {
    console.log(this.$router)
    this.getList()
    this.abilityTypeSelect(0)
  },
  computed: {
    rowSelection() {
      return {
        type: 'radio',
        selectedRowKeys: this.conselectedRow,
        onChange: (selectedRowKeys, selectedRows) => {
          if (selectedRowKeys[0] === this.conselectedRow[0]) {
            this.conselectedRow = []
          } else {
            this.conselectedRow = selectedRowKeys
            this.selectedRows = selectedRows
          }
        },
        getCheckboxProps: (record) => ({
          props: {
            disabled: this.relationModle.part.filter((f, i) => i !== this.currentPart && f.id === record.id).length > 0,
          },
        }),
      }
    },
  },
  methods: {
    changeSort(_, __, sort) {
      console.log(sort)
      const { order='',field} = sort
      const map = {
        ascend:'Asc',
        descend:'Desc'
      }
      if(field=='createTime'){
        this.search.createDesc = map[order]
        this.search.updateDesc = undefined
      }
      if(field=='updateTime'){
        this.search.updateDesc = map[order]
        this.search.createDesc = undefined
      }
      this.getList()
    },
    // 常模配置
    normSeting(record) {
      this.$store.commit("content/setAbilityInfo", record);
      window.open(
        '/content/NormSeting?classifyTag=4&activekey=1&type=game&name='+this.drawer.info.name+'&id=' +
          record.id +
          '&version=' +
          this.drawer.contentVersion +
          '&contentId=' +
          this.drawer.contentId +
          '&ContentAlgorithmCodeConfigId=' +
          record.codeBindId +
          '&abilityId=' +
          record.abilityTypeId
      )
    },
    Statistics(text) {
      this.$store.commit('content/setEvaluationGameInfo', text)
      window.open('/content/BusinessEvaluation/Statistics?type=1&name=' + text.name + '&versionName=' + text.versionName)
    },
    test() {},
    getList(pageIndex) {
      let params = {
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.search,

      }
      for (let paramsKey in params) {
        if (params[paramsKey] === null) {
          params[paramsKey] = undefined;
        }
      }
      this.$router.push({
        query: {
          ...this.$route.query,
          ...this.search,
        },
      })
      this.tableRelevant.tableLoading = true
      this.$http.contentlist(params).then((res) => {
          const data = res.data
          this.tableRelevant.tableDataSource = data.items
          this.tableRelevant.tablePagination.total = data.totalCount
          this.tableRelevant.tablePagination.current = data.pageIndex
      }).finally(() => {
        this.tableRelevant.tableLoading = false
      })
    },
    // 获取详情
    getDetailByid(record) {
      let params = {
        id: record.id,
      }
      this.$http.getDetailByid(params).then((res) => {
        const { data } = res.data
        this.drawer.visible = true
        this.drawer.contentVersion = data.versions.filter((f) => f.enabled)[0].version
        this.drawer.data = {
          applicableGender: data.applicableGender,
          minAge: data.minAge,
          maxAge: data.maxAge,
          optimumAge: data.optimumAge,
          hardwareRequirements: data.hardwareRequirements,
          suitableCourses: data.suitableCourses,
        }
      })
    },
    getAbilityWithAlgorithmCode(record) {
      let params = {
        contentId: record.id,
      }
      this.$http.getAbilityWithAlgorithmCode(params).then((res) => {
        const { data } = res.data
        this.drawer.tableRelevant.tableDataSource = data
      })
    },
    resetSearch() {},

    // 能力维度
    onChange(value) {
      this.search.AbilityTypeId = value[0]
      this.search.FirstAbilityId = value[1]
      this.search.SecondAbilityId = value[2]
      this.selectId = value
    },
    loadData(selectedOptions) {
      return new Promise((resolve, reject) => {
        const targetOption = selectedOptions[selectedOptions.length - 1]
        targetOption.loading = true
        targetOption.children = []
        let params = {
          pid: targetOption.id,
          abilityType: 0,
        }
        this.$http.abilitySelect(params).then((res) => {
          targetOption.loading = false
          targetOption.children = res.data.data.map((m) => ({ ...m, value: m.id, label: m.name, isLeaf: m.levelNumber > 1 }))
          this.options = [...this.options]
          resolve(targetOption.children)
        })
      })
    },
    abilityTypeSelect(level) {
      let params = {
        level: level,
        abilityType: 0,
      }
      this.$http.abilitySelect(params).then((res) => {
          this.options = res.data.data
          this.options.forEach((item) => {
            item.value = item.id
            item.label = item.name
            item.isLeaf = false
          })
          if (this.search.AbilityTypeId) {
            this.loadData(this.options.filter((f) => f.id === this.search.AbilityTypeId)).then((data) => {
              if (this.search.FirstAbilityId) {
                this.loadData(data.filter((f) => f.id === this.search.FirstAbilityId))
              }
            })
          }
      })
    },

    addEgame() {
      this.$store.commit('content/setEvaluationGameInfo', '')
      this.$router.push({
        path: '/content/BusinessEvaluation/EvaluationgameSeting',
        query: {
          type: 'add',
          classifyTag: 1,
        },
      })
    },

    onClose() {
      this.drawer.visible = false
    },

    // 编辑
    edit(record) {
      this.$store.commit('content/setEvaluationGameInfo', { fullPath: this.$route.fullPath, ...record })
      sessionStorage.setItem('evacurrentId', record.id) //id
      sessionStorage.setItem('currentName', record.name) //name
      sessionStorage.setItem('currentEnabled', record.enabled) //name
      this.$router.push({
        path: '/content/BusinessEvaluation/EvaluationgameSeting',
        query: {
          type: 'edit',
          id: record.id,
          contentName: record.name,
          versionName: record.versionName,
          classifyTag: 1,
        },
      })
    },
    // 转商用
    toScience(record) {
      this.$confirm({
        title: `确认将该游戏转为科研游戏？`,
        centered: true,
        onOk: () => {
          let formData = new FormData()
          formData.append('ContentId', record.id)
          formData.append('classifyTag', 4)
          this.$message.destroy()
          this.$http.UpdataClassifyTag(formData).then((res) => {
            this.$message.success('操作成功')
            this.getList(1)
          })
        },
      })
    },
    viewGame(record) {
      window.open(record.uri)
    },

    // 绑定视频 //
    video(text) {
      this.relationModle = {
        visible: false,
        part: [
          { contentName: '', firstAbilityName: '' },
          { contentName: '', firstAbilityName: '' },
          { contentName: '', firstAbilityName: '' },
        ],
      }
      this.getVideoInfo(text)
      this.contentId = text.id
      this.getSelect()
    },
    getVideoInfo(text) {
      let params = {
        contentId: text.id,
      }
      this.$http
        .GetContentRelevanceByContentId(params)
        .then((res) => {
          const { data, message } = res.data
          this.relationModle.visible = true
          if (data.length) {
            this.relationModle.part = this.relationModle.part.map((m, i) => {
              if (data[i]) {
                return {
                  contentName: data[i].linkContentName,
                  firstAbilityName: data[i].linkContentAbilityName,
                  id: data[i].linkContentId,
                }
              }
              return m
            })
          }
        })
        .catch((err) => {
          // this.loading = false
        })
    },
    getSelect() {
      let params = {
        isSelect: true,
        abilityType: 0,
      }
      this.$http.loadallsel(params).then((res) => {
        this.treeData = res.data.data
      })
    },
    pick(item, index) {
      this.conselectedRow = []
      this.pickModle.visible = true
      this.currentPart = index
      this.conselectedRow.push(this.relationModle.part[index].id)
      this.getModleList(1)
      this.$nextTick(() => {
        this.$refs.videoTable.$el.addEventListener('click', this.cancelTableRadio, true)
      })
    },
    //选择视频
    pickOk() {
      if (!this.relationModle.part.filter((f) => f.id).length) {
        if (!this.selectedRows.length) {
          this.$message.destroy()
          this.$message.error('请选择视频')
          return
        }
      }

      if (this.selectedRows.length) {
        this.relationModle.part[this.currentPart] = this.selectedRows[0]
        this.pickModle.visible = false
      } else {
        this.relationModle.part[this.currentPart] = { contentName: '', firstAbilityName: '' }
        this.pickModle.visible = false
      }
      this.selectedRows = []
    },
    cancelTableRadio(ev) {
      const e = ev || event
      if (typeof e.target.checked === 'boolean') {
        if (this.oldRadioValue == e.target.value) {
          this.conselectedRow = []
          this.selectedRows = []
        } else {
          this.oldRadioValue = e.target.value
        }
        //e.target.checked = !e.target.checked
      }
    },
    getModleList(pageIndex) {
      let params = {
        pageIndex: pageIndex || this.relationModleTableRelevant.tablePagination.current,
        pageSize: this.relationModleTableRelevant.tablePagination.pageSize,
        name: this.pickModle.name,
        firstAbilityId: this.pickModle.firstAbilityId,
        ContentType: 4,
        ScientificName: '游戏指导',
      }
      this.$http
        .EGamegelist(params)
        .then((res) => {
          this.tableExpandedRowKeys = []
          res.data.data.items.forEach((v) => {
            v.firstAbilityName = v.abilitys.length ? v.abilitys[0].firstAbilityName : ''
          })
          this.relationModleTableRelevant.tableDataSource = res.data.data.items
          this.relationModleTableRelevant.tablePagination.total = res.data.data.totalCount
          this.relationModleTableRelevant.tablePagination.current = res.data.data.pageIndex
          console.log(this.relationModleTableRelevant.tableDataSource)
        })
        .catch((err) => {
          this.loading = false
        })
    },
    // 关联视频
    relationOk() {
      let params = {
        contentId: this.contentId,
        links: [],
      }
      let arr = []
      console.log(this.relationModle.part)
      this.relationModle.part.forEach((v, i) => {
        let str = {
          linkContentId: '',
          relevanceType: 1,
          sortIndex: i + 1,
        }
        if (v.id) {
          str.linkContentId = v.id
          arr.push(str)
        }
      })
      params.links = arr
      console.log(params)
      // return
      this.$http
        .RelevanceVideo(params)
        .then(() => {
          this.$message.success('关联成功')
          this.relationModle = {
            visible: false,
            part: [
              { contentName: '', firstAbilityName: '' },
              { contentName: '', firstAbilityName: '' },
              { contentName: '', firstAbilityName: '' },
            ],
          }
        })
        .catch(() => {
          this.$message.error('系统异常')
        })
    },
  },
}
</script>

<style scoped>
.table_div {
  display: flex;
  align-items: center;
}
.table_icon {
  color: #ff9904;
  font-size: 20px;
  margin-right: 5px;
}
.BusinessEvaluation >>> .standard-table .alert {
  display: none !important;
}

.BusinessEvaluation >>> .searchForm {
  display: flex;
}
.BusinessEvaluation >>> .searchForm .fold {
  width: 91%;
  display: flex;
}
.sbtn {
  display: flex;
  align-items: center;
  height: 40px;
}
</style>
<style lang="less" scoped>
.card {
  h5 {
    margin-top: 15px;
    font-size: 18px;
    font-weight: 600;
  }
  .item {
    display: flex;
    align-items: center;
    margin-top: 15px;
    padding: 0 5px;
    span {
      color: #8f8f8f;
    }
    em {
      font-style: normal;
      margin-left: 15px;
      color: #000;
    }
  }
}

/deep/ .ant-table-tbody .testClass {
  padding: 0 !important;
}
.self_td {
  height: 54px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  justify-content: center;
}
.inBox {
  height: 32px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0 10px;
}
.inBox:hover {
  border-color: #36cfc9;
  border-right-width: 1px !important;
}
.part {
  display: flex;
  align-items: center;
}
</style>
